import { useState } from 'react';
import { isAdmin } from '../util';
import EditRecipeForm from './EditRecipeForm';
import { doc, deleteDoc } from '@firebase/firestore';
import { database } from '../firebase';
import { useTranslation } from 'react-i18next';

const Recipe = ({ recipe }) => {
  const { t } = useTranslation();

  const [weight, setWeight] = useState(recipe.standardWeightInGrams);

  const calculateWeight = percentage => (percentage / 100) * weight;

  const deleteRecipe = async () => {
    if (window.confirm(`Are you sure you want to delete '${recipe.title}'`)) {
      await deleteDoc(doc(database, 'recipes', recipe.id));
      alert(`'${recipe.title}' was deleted.`);
    }
  };

  return (
    <div>
      <label htmlFor="weight">{t('weightInGrams')}</label>
      <input
        type="number"
        name="weight"
        id="weight"
        value={weight}
        onChange={event => setWeight(event.target.value)}
      />
      <h2>{recipe.title}</h2>
      <div dangerouslySetInnerHTML={{ __html: recipe.markup }} />
      <h3>{t('ingredients')}</h3>
      <ul>
        {recipe.ingredients.map((ingredient, index) => (
          <li key={ingredient.name + '-' + index}>
            {ingredient.name} - {calculateWeight(ingredient.percentage)}g
          </li>
        ))}
      </ul>
      {isAdmin() && (
        <>
          <button onClick={deleteRecipe} className="delete-recipe-button">
            {t('deleteRecipe')}
          </button>
          <EditRecipeForm key={recipe.id} recipe={recipe} />
        </>
      )}
    </div>
  );
};

export default Recipe;
